import { render, staticRenderFns } from "./m-create-user-for-employee.vue?vue&type=template&id=164f2591&scoped=true&"
import script from "./m-create-user-for-employee.vue?vue&type=script&lang=js&"
export * from "./m-create-user-for-employee.vue?vue&type=script&lang=js&"
import style0 from "./m-create-user-for-employee.vue?vue&type=style&index=0&id=164f2591&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164f2591",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('164f2591')) {
      api.createRecord('164f2591', component.options)
    } else {
      api.reload('164f2591', component.options)
    }
    module.hot.accept("./m-create-user-for-employee.vue?vue&type=template&id=164f2591&scoped=true&", function () {
      api.rerender('164f2591', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employees/m-create-user-for-employee.vue"
export default component.exports